var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3240(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3240",
    "data-name": "Group 3240",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.197,
    height: 50,
    viewBox: "0 0 44.197 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2139",
    "data-name": "Group 2139",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M-427.3,129.12h35.5V87.033h-35.434a3.173,3.173,0,0,1,3.034-3.95c4.011-.019,8.022-.008,12.033-.008q10.508,0,21.016,0a3.17,3.17,0,0,1,3.214,2.443,4.136,4.136,0,0,1,.087.988q.007,21.571,0,43.142a3.221,3.221,0,0,1-3.446,3.421q-16.248,0-32.5,0C-426.154,133.071-427.531,131.556-427.3,129.12Z",
    transform: "translate(432.049 -83.072)",
    fill: "#f18181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M-303.518,219.246a4.664,4.664,0,0,1-3.827-1.507,15.672,15.672,0,0,1-3.135-5.244,39.681,39.681,0,0,1-2.639-9.344,10.545,10.545,0,0,1,.172-4.45,4.242,4.242,0,0,1,2.655-2.918c.772-.3,1.571-.531,2.361-.784a.562.562,0,0,1,.809.415q1.012,3.246,2.046,6.485a.522.522,0,0,1-.4.755c-.509.163-1.011.355-1.528.482a.942.942,0,0,0-.761.948,7.192,7.192,0,0,0,.436,3.32,22.607,22.607,0,0,0,1.523,3.234c.424.74.735.76,1.544.507.457-.143.912-.294,1.372-.429a.513.513,0,0,1,.717.392c.693,2.178,1.407,4.348,2.077,6.533a.729.729,0,0,1-.256.654C-301.568,218.7-302.807,219.039-303.518,219.246Z",
    transform: "translate(330.631 -182.54)",
    fill: "#f18181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M-465.29,143.8c.813,0,1.627-.013,2.44,0a1.605,1.605,0,0,1,1.7,1.586,1.615,1.615,0,0,1-1.642,1.717q-2.522.054-5.045,0a1.625,1.625,0,0,1-1.648-1.713,1.609,1.609,0,0,1,1.7-1.591C-466.954,143.788-466.122,143.8-465.29,143.8Z",
    transform: "translate(469.514 -137.06)",
    fill: "#f18181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M-465.241,203.805c.795,0,1.59-.014,2.384,0a1.6,1.6,0,0,1,1.7,1.639,1.633,1.633,0,0,1-1.7,1.669q-2.466.036-4.934,0a1.64,1.64,0,0,1-1.707-1.66,1.608,1.608,0,0,1,1.7-1.646C-466.941,203.791-466.091,203.805-465.241,203.805Z",
    transform: "translate(469.519 -190.408)",
    fill: "#f18181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M-465.333,263.809c.831,0,1.663-.016,2.495,0a1.6,1.6,0,0,1,1.681,1.606,1.6,1.6,0,0,1-1.609,1.691c-1.7.042-3.4.039-5.1,0a1.617,1.617,0,0,1-1.629-1.676,1.6,1.6,0,0,1,1.667-1.622C-467,263.793-466.164,263.81-465.333,263.809Z",
    transform: "translate(469.523 -243.755)",
    fill: "#f18181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M-465.5,323.826c.832,0,1.663-.012,2.495,0a1.6,1.6,0,0,1,1.612,1.379,1.611,1.611,0,0,1-1.271,1.86,1.429,1.429,0,0,1-.325.06c-1.7,0-3.4.023-5.1,0a1.623,1.623,0,0,1-1.56-1.13,1.538,1.538,0,0,1,.493-1.753,2.129,2.129,0,0,1,1.052-.4C-467.245,323.788-466.373,323.826-465.5,323.826Z",
    transform: "translate(469.751 -297.109)",
    fill: "#f18181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M-465.322,383.807c.831,0,1.664-.016,2.495,0a1.6,1.6,0,0,1,1.673,1.615,1.607,1.607,0,0,1-1.617,1.685q-2.549.057-5.1,0a1.617,1.617,0,0,1-1.62-1.684,1.607,1.607,0,0,1,1.675-1.615C-466.986,383.791-466.154,383.807-465.322,383.807Z",
    transform: "translate(469.521 -350.442)",
    fill: "#f18181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M-465.319,443.808c.832,0,1.664-.016,2.495,0a1.6,1.6,0,0,1,1.669,1.618,1.61,1.61,0,0,1-1.621,1.682q-2.549.056-5.1,0a1.615,1.615,0,0,1-1.616-1.687,1.606,1.606,0,0,1,1.679-1.611C-466.983,443.793-466.151,443.808-465.319,443.808Z",
    transform: "translate(469.522 -403.787)",
    fill: "#f18181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3240);
export default __webpack_public_path__ + "static/media/Group 3240.f274f8d074aba07356aafb4aaa2c619f.svg";
export { ForwardRef as ReactComponent };